import { TextTemplateClient } from './TextTemplates'
import store from 'src/store'

export class InvoiceTextTemplateClient extends TextTemplateClient {
  /**
   * InvoiceTextTemplates constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/invoice-text-templates`
  }
}
